
<template>

    <!-- Page Title -->
    <section id="page-title">

        <div class="container clearfix">
            <h1>{{$t("HomePage-FAQ")}}</h1>
        </div>

    </section>
    <!-- #page-title end -->

    <!-- Content -->
    <section id="content">
        <div class="content-wrap">
            <div class="container">
            </div>


            <div v-html="compiledHtml">

            </div>


        </div>
    </section>
    <!-- #content end -->
    
</template>


<script>
    export default {
        name: 'CommonQuestionComponent',
        data: function () {
            return {
                html: ""
            };
        },
        created() {
            this.loadFile();
        },
        computed: {
            compiledHtml: function () {
                
                return this.html;
            }
        },
        updated() {
            const plugin = document.createElement("script");
            plugin.setAttribute(
                "src",
                process.env.BASE_URL + 'Content/js/functions.js'
            );
            plugin.async = true;
            document.head.appendChild(plugin);
        },
        methods: {
            loadFile() {
     var htmlpathHeader = "";
                if (localStorage.getItem('Public_lang') == 'en-us') {
                    htmlpathHeader = process.env.BASE_URL + 'Content/HTMLFiles/CommonQuestionsEN.html';
                } else {
                    htmlpathHeader = process.env.BASE_URL + 'Content/HTMLFiles/CommonQuestionsAR.html';
                }
            
    fetch(htmlpathHeader, {
                    method: "get"
                })
                    .then(r => r.text())
                    .then(result => {
                        this.html = result;
                    })
                    .catch(error => {
                        console.error("error getting file");
                    });
            }
        }
    }

</script>
